import { styled, svgIconClasses } from "@mui/material";
import { colorPickerName } from "../../../../../classes.js";
import { borderWidth, Chip } from "../../../../Swatch/components/Chip.js";
const AdornmentChip = styled(Chip, {
  name: colorPickerName,
  slot: "AdornmentChip"
})(({ size }) => {
  return {
    [`& .${svgIconClasses.root}`]: {
      fontSize: size - borderWidth * 2,
      opacity: 1,
      scale: "1"
    }
  };
});
export {
  AdornmentChip
};
//# sourceMappingURL=AdornmentChip.js.map
